import {staticPaths} from 'routes/staticPaths'
import {
    ArticleExplorer,
    AskExplorer,
    ChannelExplorer,
    CourseExplorer,
    ExaminationExplorer,
    OrganizationExplorer
} from 'views/AppLocals/factory/createDiscoveryExplorer'
import {withSearchParams} from 'views/AppLocals/functions/routerHelper'
import {SearchParams, SearchTypes} from 'views/Search/SearchProvider'
import {
    BiblesExplorer,
    DefinitionExplorer,
    DiocesesExplorer,
    DivineWordExplorer,
    EcclesiasticDocumentExplorer,
    EvangelizationExplorer,
    MassTimeExplorer,
    PilgrimageExplorer,
    ProfilesExplorer,
    ReligiousOrdersExplorer
} from "../AppLocals/factory/createDiscoveryExplorer";
import {gPaths} from "../AppLocals/configs";
import {staticAppIdNames} from "../../conts/staticAppIdNames";
import {FaBookOpenReader, FaCross, FaUserTie} from "react-icons/fa6";
import {BsCalendar2WeekFill, BsLayersHalf, BsNewspaper, BsPuzzleFill} from "react-icons/bs";
import {IoLibraryOutline} from "react-icons/io5";
import {GiIronCross} from "react-icons/gi";
import {PiMusicNotesFill, PiPulse} from "react-icons/pi";
import {RiGraduationCapFill} from "react-icons/ri";
import {MissalsSvg} from "../../components/Svgs/MissalsSvg";
import {EvangelizationSvg} from "../../components/Svgs/EvangelizationSvg";
import React from "react";
import {TurnToChristSvg} from "../../components/Svgs/TurnToChristSvg";
import {PrayerBook, PrayerHandSvg, PrayerIntentionIcon} from "../../components/Svgs/PrayersSvg";
import {MdOutlineQuestionAnswer} from "react-icons/md";
import {MassTimePlaceFillSvg, MassTimeTileIcon} from "../../components/Svgs/MassTimeIconSvg";
import {PilgrimageSvg} from "../../components/Svgs/PilgrimageSvg";
import {LuNotebookPen} from "react-icons/lu";
import {HolyFamilySvg} from "../../components/Svgs/HolyFamilySvg";
import {FamilyIcon} from "../../components/Svgs/FamilyIconSvg";
import {LearnPlayIcon} from "../../components/Svgs/LearnPlayIconSvg";
import {DirectoryIcon} from "../../components/Svgs/DirectoryIconSvg";
import {LibraryIcon} from "../../components/Svgs/LibraryIconSvg";
import {HymnIcon} from "../../components/Svgs/HymnIconSvg";

// `icon` = icon ĐƠN GIẢN gốc (đơn sắc, currentColor) - GIỮ NGUYÊN cho các trang KHÁC đang dùng chung
// data này (SpaceWebApps.js có tới 5-6 kiểu card khác nhau đọc thẳng `item.icon`, có card render icon
// 2 LẦN ở 2 size rất khác nhau - 100px làm hình mờ nền + 22px trong vòng tròn riêng, xem
// SectionHeroBanner) - phản hồi thực tế đã gặp: đổi `icon` sang icon ghép mới (nền/màu/vị trí tự vẽ
// bên trong, không đổi theo context) làm 1 card bị "to ra, lệch giữa, mất cân đối" ở trang đó.
// `tileIcon` = icon GHÉP 2-trong-1 mới - CHỈ AppGroupBlock (sidebar "Tính năng nổi bật") đọc field
// này (ưu tiên tileIcon, fallback icon nếu không có) - đúng ĐÚNG 1 chỗ đã được yêu cầu đổi kiểu icon,
// không ảnh hưởng các trang khác đang dùng `icon` theo đúng hợp đồng cũ (currentColor, 1 icon đơn).

const rootPath = staticPaths.discovery.pathname

export const discoveryMapExplorerRouteEntities = [
    {
        type: SearchTypes.BIBLES,
        component: BiblesExplorer,
        href: {pathname: staticPaths.documentLibrary.pathname, search: '?view=bible'},
    },
    {
        type: SearchTypes.PROFILES,
        href: staticPaths.profiles,
        component: ProfilesExplorer,
    },

    {
        type: SearchTypes.ECCLESIASTIC,
        component: EcclesiasticDocumentExplorer,
        path: staticPaths.documentLibrary.pathname + '?view=global'
    },
    {
        type: SearchTypes.DEFINITION,
        component: DefinitionExplorer,
        path: staticPaths.definitions.pathname
    },
    {
        type: SearchTypes.ARTICLE,
        component: ArticleExplorer,
        hint: 'articles',
    },
    {
        type: SearchTypes.ASK,
        href: staticPaths.discussions,
        component: AskExplorer,
    },
    {
        type: SearchTypes.CHANNEL,
        component: ChannelExplorer,
    },
    {
        type: SearchTypes.EXAMINATION,
        component: ExaminationExplorer,
    },
    {
        type: SearchTypes.COURSE,
        href: staticPaths.edu,
        component: CourseExplorer,
    },
].map(({type, ...props}) => {
    const search = `${SearchParams.TYPE}=${type}`
    return {
        type,
        search,
        pathname: rootPath,
        getSearch: withSearchParams({
            [SearchParams.TYPE]: type,
            [SearchParams.KEYWORD]: undefined,
        }),
        path: [rootPath, search].join('?'),
        color: 'text-green-500',
        ...props,
    }
})

export const activitiesOfTheChurchMapExplorer = [
    {
        type: SearchTypes.ORGANIZATION,
        component: OrganizationExplorer,
        href: staticPaths.organizations,
    },
    {
        type: SearchTypes.DIOCESES,
        component: DiocesesExplorer,
        href: staticPaths.dioceses,
    },
    {
        type: SearchTypes.RELIGIOUS_ORDERS,
        component: ReligiousOrdersExplorer,
        href: staticPaths.religiousOrder,
    },
    {
        type: SearchTypes.CHURCHES,
        component: MassTimeExplorer,
        href: staticPaths.churches,
    },
    {
        type: SearchTypes.PILGRIMAGE,
        component: PilgrimageExplorer,
        href: staticPaths.pilgrimage,
    },
    {
        type: SearchTypes.EVANGELIZATION,
        component: EvangelizationExplorer,
        href: staticPaths.evangelization.pathname,
    },
].map(({type, ...props}) => {
    const search = `${SearchParams.TYPE}=${type}`
    return {
        type,
        search,
        pathname: rootPath,
        getSearch: withSearchParams({
            [SearchParams.TYPE]: type,
            [SearchParams.KEYWORD]: undefined,
        }),
        path: [rootPath, search].join('?'),
        color: 'text-blue-500',
        ...props,
    }
})

export const feature2ExplorerRouteEntities = [
    {
        type: SearchTypes.DIVINE_WORD,
        component: DivineWordExplorer,
        searchable: false,
    },
].map(({type, ...props}) => {
    const search = `${SearchParams.TYPE}=${type}`
    return {
        type,
        search,
        pathname: rootPath,
        getSearch: withSearchParams({
            [SearchParams.TYPE]: type,
            [SearchParams.KEYWORD]: undefined,
        }),
        path: [rootPath, search].join('?'),
        color: 'text-primary-700',
        size: 30,
        ...props,
    }
})

export const featureExplorerRouteEntities = [
    {
        key: 'lectionary',
        label: "lectionary",
        icon: FaBookOpenReader,
        href: gPaths.book.replace(":id", staticAppIdNames.LECTIONARY_BOOK_VI),
    },
    {
        key: 'prayer',
        label: "prayer",
        icon: PrayerBook,
        href: "/prayer-books",
        size: 28,
    },
    {
        key: 'music',
        label: "music",
        icon: PiMusicNotesFill,
        href: "/musics",
    },
    {
        key: 'liturgical_prayers',
        label: "liturgical prayers",
        icon: GiIronCross,
        href: "/liturgical",
        size: 23,
    },
    {
        key: 'liturgy_calendar',
        label: "liturgy calendar",
        icon: BsCalendar2WeekFill,
        href: staticPaths.calendar,
        size: 23,
    },
    {
        key: SearchTypes.MISSALS,
        label: "missals",
        icon: MissalsSvg,
        href: staticPaths.missals,
        size: 23,
    },
    {
        key: 'prayers',
        label: "prayer intention",
        icon: PrayerHandSvg,
        href: staticPaths.devotions.pathname + "?tab=intentions",
        size: 28,
    },
].map(({type, ...props}) => {
    const search = `${SearchParams.TYPE}=${type}`
    return {
        type,
        search,
        pathname: rootPath,
        getSearch: withSearchParams({
            [SearchParams.TYPE]: type,
            [SearchParams.KEYWORD]: undefined,
        }),
        path: [rootPath, search].join('?'),
        ...props,
    }
})

export const privateExplorerRouteEntities = [
    {
        key: 'journey-to-christ',
        label: "journey to god",
        icon: TurnToChristSvg,
        href: staticPaths.turnToChrist.pathname,
    },
    {
        key: 'evangelization',
        label: "evangelization",
        icon: EvangelizationSvg,
        href: staticPaths.evangelization.pathname,
    },
    {
        key: 'activities',
        label: "my activities",
        icon: PiPulse,
        href: "/my-activities",
    },
].map(({type, ...props}) => {
    const search = `${SearchParams.TYPE}=${type}`
    return {
        type,
        search,
        pathname: rootPath,
        getSearch: withSearchParams({
            [SearchParams.TYPE]: type,
            [SearchParams.KEYWORD]: undefined,
        }),
        path: [rootPath, search].join('?'),
        ...props,
    }
})

// discoveryMapExplorerRouteEntities.js — updated groups

export const functionGroups = {
    knowledge: {
        title: "Bible & Faith Formation",
        subtitle: "A Strong Foundation in Christianity",
        value: 'knowledge'
    },
    liturgy: {
        title: "Prayer & Liturgy",
        subtitle: "A Daily Encounter with God",
        value: 'liturgy'
    },
    education: {
        title: "Journey of Faith & Learning",
        subtitle: "For Exploration, Deepening, and Formation",
        value: 'education'
    },
    partner: {
        title: "Community Life & Mission",
        subtitle: "Living the Faith Together",
        value: 'partner'
    },
    // NEW group: tách riêng các mục "Khám phá / Discover"
    discover: {
        title: "Spiritual Journey",
        subtitle: "Explore, Discover, and Go Deeper",
        value: 'discover'
    },
}

export const functionRouteEntities = [

    {
        group: 'liturgy',
        key: 'prayer',
        label: "prayer",
        size: 30,
        icon: ({style, ...props}) => (
            <PrayerBook style={{margin: 0, ...style}} {...props} />
        ),
        href: staticPaths.prayerBooks.pathname,
        highlight: true,
        popular: true,
        sort_order: 999,
        tag: 'laity',
    },
    {
        group: 'suggested-deprecated',
        key: 'spiritual-journal',
        label: "Sacred Journal",
        size: 30,
        icon: ({style, ...props}) => (
            <LuNotebookPen style={{margin: 0, ...style}} {...props} />
        ),
        href: staticPaths.spiritualJournal.pathname,
        popular: true,
        sort_order: 998,
        // tag: 'minister',
    },
    {
        group: 'spirituality',
        key: 'spirituality',
        label: "spirituality",
        subtitle: "spirituality_heading",
        href: staticPaths.spiritualPath.pathname,
        size: 30,
        icon: ({style, ...props}) => (
            <FaCross style={{margin: 0, ...style}} {...props} />
        ),
        highlight: true,
        popular: true,
        sort_order: 998,
        tag: 'laity',
    },
    {
        group: 'suggested',
        key: 'prayers',
        label: "united in prayer",
        subtitle: "The Power of Communion",
        href: staticPaths.devotions.pathname + "?tab=intentions",
        size: 30,
        icon: ({style, ...props}) => (
            <PrayerHandSvg style={{margin: 0, ...style}} {...props} />
        ),
        // tileIcon - CHỈ sidebar "Tính năng nổi bật" đọc field này. Icon ghép FaHands+thánh giá
        // (PrayerIntentionIcon) thay PrayerHandSvg (minh hoạ tay vẽ tay phức tạp) - đồng bộ phong
        // cách "icon ghép nền màu đặc" đã áp dụng cho Hymns/Mass Times. Màu HARDCODE #624280
        // (= --color-prayer-700) - biến đó CHỈ định nghĩa trong scope `.prayer-theme`, sidebar này
        // nằm NGOÀI scope đó (cùng lý do đã gặp ở Hymns).
        tileIcon: ({size = 30, style, className}) => (
            <PrayerIntentionIcon
                size={size}
                bgColor="#624280"
                handsColor="#fff"
                style={{borderRadius: size * 0.3, margin: 0, ...style}}
                className={className}
            />
        ),
        highlight: true,
        popular: true,
        sort_order: 11,
        tag: 'laity',
    },

    {
        group: 'liturgy',          // PHỤNG VỤ cột phải
        key: 'music',
        label: "hymns",
        size: 30,
        icon: ({style, ...props}) => (
            <PiMusicNotesFill style={{margin: 0, ...style}} {...props} />
        ),
        // tileIcon - CHỈ sidebar "Tính năng nổi bật" đọc field này. HymnIcon approach B (note + thánh
        // giá MERGE thành 1 silhouette màu riêng, xem comment trong HymnIconSvg.js) render TRỰC TIẾP,
        // KHÔNG bọc div nền màu đặc - ĐÃ THỬ bọc nền xanh #1d4ed8 (giữ lại từ bản note trắng đơn cũ,
        // cần nền vì icon cũ không có màu riêng) - phản hồi thực tế "lạc quẻ": mọi tileIcon anh em khác
        // trong list này (FamilyIcon/MassTimeTileIcon/LearnPlayIcon/DirectoryIcon/LibraryIcon) đều nền
        // trong suốt, tự có màu riêng, không bọc khối nền - bỏ div nền để đồng bộ đúng quy ước.
        tileIcon: ({style, ...props}) => (
            <HymnIcon style={{margin: 0, ...style}} {...props} />
        ),
        href: staticPaths.hymns.pathname,
        popular: true,
        sort_order: 5,
        tag: 'laity',
    },
    {
        group: 'liturgy',          // PHỤNG VỤ cột phải
        key: 'liturgical_prayers',
        label: "liturgical prayers",
        size: 30,
        icon: ({style, ...props}) => (
            <GiIronCross style={{margin: 0, ...style}} {...props} />
        ),
        href: staticPaths.liturgical.pathname,
        sort_order: 999,
        tag: 'minister',
    },
    {
        group: 'liturgy',          // PHỤNG VỤ cột phải
        key: SearchTypes.MISSALS,
        label: "missals",
        size: 30,
        icon: ({style, ...props}) => (
            <MissalsSvg style={{margin: 0, ...style}} {...props} />
        ),
        href: staticPaths.missals.pathname,
        sort_order: 12,
        tag: 'priests & religious',
    },
    {
        group: 'liturgy',          // PHỤNG VỤ cột phải
        key: 'liturgy_calendar',
        label: "liturgy calendar",
        href: staticPaths.liturgicalCalendar.pathname,
        size: 30,
        icon: ({style, ...props}) => (
            <BsCalendar2WeekFill style={{margin: 0, ...style}} {...props} />
        ),
        sort_order: 999,
        tag: 'general',
    },

    {
        group: 'knowledge_removed',
        key: 'profiles',
        label: "profile",
        subtitle: "profiles_subtitle",
        href: staticPaths.profiles.pathname,
        size: 30,
        icon: ({style, ...props}) => (
            <FaUserTie style={{margin: 0, ...style}} {...props} />
        ),
        popular: true,
        sort_order: 999,
        tag: 'general',
    },

    // ── HỌC HỎI ĐỨC TIN (education) ─────────────────────
    // "documents": thay cho 3 mục Kinh Thánh/Văn kiện/Điển ngũ trước đây (nay đã gộp về
    // /documents "Thư viện Công giáo" — xem group 'knowledge_removed' phía trên).
    {
        group: 'education',
        key: 'documents',
        label: "catholic library",
        href: staticPaths.documentLibrary.pathname,
        size: 30,
        icon: ({style, ...props}) => (
            <IoLibraryOutline style={{margin: 0, ...style}} {...props} />
        ),
        tileIcon: ({style, ...props}) => (
            <LibraryIcon style={{margin: 0, ...style}} {...props} />
        ),
        highlight: true,
        popular: true,
        sort_order: 1,
        tag: 'laity',
    },
    {
        group: 'education',
        key: 'asks',
        label: 'q-and-a',
        href: staticPaths.discussions.pathname,
        size: 30,
        icon: ({style, ...props}) => (
            <MdOutlineQuestionAnswer style={{margin: 0, ...style}} {...props} />
        ),
        sort_order: 13,
        tag: 'study',
    },

    {
        group: 'education',
        key: 'games',
        label: "games",
        href: staticPaths.games.pathname,
        size: 30,
        icon: ({style, ...props}) => (
            <BsPuzzleFill style={{margin: 0, ...style}} {...props} />
        ),
        tileIcon: ({style, ...props}) => (
            <LearnPlayIcon style={{margin: 0, ...style}} {...props} />
        ),
        sort_order: 4,
        tag: 'general',
    },
    {
        group: 'education',
        key: 'channels',
        label: "channels",
        href: staticPaths.news.pathname,
        size: 30,
        icon: ({style, ...props}) => (
            <BsNewspaper style={{margin: 0, ...style}} {...props} />
        ),
        sort_order: 999,
        tag: 'general',
    },

    // ── KHÁM PHÁ / DISCOVER (discover) — group mới ─────
    {
        group: 'discover',         // trước: education
        key: 'journey-to-christ',
        label: "journey to god",
        subtitle: "journey-to-christ_subtitle",
        href: staticPaths.turnToChrist.pathname,
        size: 30,
        icon: ({style, ...props}) => (
            <TurnToChristSvg style={{margin: 0, ...style}} {...props} />
        ),
        popular: true,
        sort_order: 999,
        tag: 'laity',
    },
    {
        group: 'discover',         // trước: partner
        key: 'pilgrimage',
        label: "pilgrimage",
        subtitle: "pilgrimage_subtitle",
        href: staticPaths.pilgrimage.pathname,
        size: 30,
        icon: ({style, ...props}) => (
            <PilgrimageSvg style={{margin: 0, ...style}} {...props} />
        ),
        popular: true,
        sort_order: 999,
        tag: 'laity',
    },
    {
        group: 'discover',         // trước: partner
        key: 'evangelization',
        label: "evangelization",
        subtitle: "evangelization_subtitle",
        href: staticPaths.evangelization.pathname,
        size: 30,
        icon: ({style, ...props}) => (
            <EvangelizationSvg style={{margin: 0, ...style}} {...props} />
        ),
        popular: true,
        sort_order: 999,
        tag: 'minister',
    },

    // ── DANH BẠ (partner) ──────────────────────────────
    {
        group: 'partner',
        key: 'churches',
        label: "mass times & churches",
        href: staticPaths.massTimes.pathname,
        size: 30,
        icon: ({style, ...props}) => (
            <MassTimePlaceFillSvg style={{margin: 0, ...style}} {...props} />
        ),
        tileIcon: ({style, ...props}) => (
            <MassTimeTileIcon style={{margin: 0, ...style}} {...props} />
        ),
        highlight: true,
        popular: true,
        sort_order: 3,
        tag: 'laity',
    },
    {
        group: 'partner',
        key: 'courses',
        label: "course directory",
        // Kristo Edu (/edu) - "Danh Bạ Khóa Học", xếp ngay dưới hero Mass Times, trước
        // "directories" trong DirectoryBlock (SpaceWebApps.js) - sort_order: 1.5 để đứng trước
        // directories (2) mà không phải renumber các entry khác.
        // Icon dùng RiGraduationCapFill - ĐÃ là icon chính thức của Kristo Education (xem header
        // EducationLandingPage.js), không tạo icon ghép mới.
        href: staticPaths.edu.pathname,
        size: 30,
        icon: ({style, ...props}) => (
            <RiGraduationCapFill style={{margin: 0, ...style}} {...props} />
        ),
        sort_order: 1.5,
        tag: 'laity',
    },
    {
        group: 'partner',
        key: 'family_books',
        label: "family books",
        // Kristo Family - Gia Phả & Sổ Gia Đình Công giáo. Nằm ngay dưới "directories" (Kristo
        // Directory, sort_order: 2) - sort_order: 2.5 để không phải renumber các entry khác.
        href: staticPaths.familyBooks.pathname,
        size: 30,
        icon: ({style, ...props}) => (
            <HolyFamilySvg style={{margin: 0, ...style}} {...props} />
        ),
        tileIcon: ({style, ...props}) => (
            <FamilyIcon heartColor="#d97706" style={{margin: 0, ...style}} {...props} />
        ),
        sort_order: 2.5,
        tag: 'laity',
    },
    {
        group: 'partner',
        key: 'directories',
        label: "directories",
        // Gộp dioceses/parishes + religious orders + Catholic Action + organizations + yellow
        // pages — cả 5 mục cũ đều đã có trong 1 trang Danh Bạ Công Giáo hợp nhất (/discovery),
        // dùng chung icon với header của trang đó để nhận diện nhất quán.
        href: staticPaths.discovery.pathname,
        size: 30,
        icon: ({style, ...props}) => (
            <BsLayersHalf style={{margin: 0, ...style}} {...props} />
        ),
        tileIcon: ({style, ...props}) => (
            <DirectoryIcon style={{margin: 0, ...style}} {...props} />
        ),
        sort_order: 2,
        tag: 'general',
    }
].map(({type, ...props}) => {
    const search = `${SearchParams.TYPE}=${type}`
    return {
        type,
        search,
        pathname: rootPath,
        getSearch: withSearchParams({
            [SearchParams.TYPE]: type,
            [SearchParams.KEYWORD]: undefined,
        }),
        path: [rootPath, search].join('?'),
        ...props,
    }
})


